<template>
  <div>
    <div class="card">
      <ToolbarHeader
        :title="pageTitle"
        :loading-refresh="false"
        @create="showModal('create', {})"
        @refresh="getAllData(true)"
        @export-excel="exportExcel"
        @export-pdf="exportPdf"
      />
      <div class="card-body">
        <a-table
                style="
                  margin-left: -26px;
                  margin-right: -26px;
                  margin-top: -21px;
                "
          :columns="columns"
          :dataSource="data"
          :rowKey="record => record.id"
          size="small"
          :pagination="{
            defaultPageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal: (total) => `Total ${total} items`,
            pageSizeOptions: ['10', '20', '30'],
          }"
        >
          <div
            slot="filterDropdown"
            slot-scope="{
              setSelectedKeys,
              selectedKeys,
              confirm,
              clearFilters,
              column,
            }"
            style="padding: 8px;"
          >
            <a-input
              v-ant-ref="(c) => (searchInput = c)"
              :placeholder="`Search ${column.title}`"
              :value="selectedKeys[0]"
              style="width: 188px; margin-bottom: 8px; display: block;"
              @change="
                (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
              "
              @pressEnter="
                () => handleSearch(selectedKeys, confirm, column.dataIndex)
              "
            />
            <a-button
              type="primary"
              icon="search"
              size="small"
              style="width: 90px; margin-right: 8px;"
              @click="
                () => handleSearch(selectedKeys, confirm, column.dataIndex)
              "
            >
              Search
            </a-button>
            <a-button
              size="small"
              style="width: 90px;"
              @click="() => handleReset(clearFilters)"
            >
              Reset
            </a-button>
          </div>
          <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
          />
          <template
            slot="customRender"
            slot-scope="text, record, index, column"
          >
            <span v-if="searchText && searchedColumn === column.dataIndex">
              <template
                v-for="(fragment, i) in text
                  .toString()
                  .split(
                    new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')
                  )"
              >
                <mark
                  v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                  :key="i"
                  class="highlight"
                  >{{ fragment }}</mark
                >
                <template v-else>{{ fragment }}</template>
              </template>
            </span>
            <template v-else>
              <span>
                {{ text }}
              </span>
            </template>
          </template>
          <span slot="action" slot-scope="text, record">
            <a-icon
              type="edit"
              class="text-warning"
              @click="showModal('update', record)"
              />
            <a-divider type="vertical"/>
            <a-icon
              type="delete"
              class="text-danger"
              @click="showDeleteConfirm(record)"
              />
          </span>
          <template slot="appLists" slot-scope="text, record">
            <a-tag v-for="(data, index) in record.appLists" :key="index">{{ data.appName }}</a-tag>
          </template>
          <template slot="periode" slot-scope="text">
            <label>{{ moment(text, 'YYYY-MM-DD').format('DD-MM-YYYY') }}</label>
          </template>
        </a-table>
      </div>
      <a-modal v-model="formvisible" :title="'Form '+ pageTitle" :dialogStyle="{ top: '10px' }">
        <template slot="footer">
          <a-button class="btn btn-outline-danger" @click="resetForm">Cancel</a-button>
          <a-button class="btn btn-outline-primary" @click="handleSubmit">Submit</a-button>
        </template>
        <div class="row">
          <FormLabel text="Nama" />
          <FormInput label="Nama" v-model="modalInput.nama" />
          <FormLabel text="Kode" />
          <FormInput label="Kode" v-model="modalInput.kode" />

          <FormLabel text="Kategori" />
          <FormSelect v-model="modalInput.kategori_id" :options="masterDataKategori" ref-name="Kategori" label="nama"/>
          <FormLabel text="Supplier" />
          <FormSelect v-model="modalInput.supplier_id" :options="masterDataSupplier" ref-name="Supplier" label="nama_perusahaan"/>

          <FormLabel text="Satuan" />
          <FormInput label="Satuan" v-model="modalInput.satuan" />
          <FormLabel text="Harga" />
          <FormNumber v-model="modalInput.harga" ref-name="harga" :cleave-options="{ numeral: true }"/>
          <FormLabel text="Re-Order" />
          <FormNumber v-model="modalInput.reorder" ref-name="reorder" :cleave-options="{ numeral: true }"/>
        </div>
      </a-modal>
    </div>
    <!-- <formModal ref="formModal" :key="componentKey" :table="table" /> -->
  </div>
</template>

<script>
// import * as lou from '@/services/data/lou'
// import { Modal } from 'ant-design-vue'
// import formModal from '../form'
import moment from 'moment'
import { createFilterableColumn, createFilterableColumn2, createNumberColumn, createActionColumn } from '@/utils/tableColumns'
import { getMasterCustom, addLabelForSelect, sendToAPI } from '@/utils/getMaster'
import ToolbarHeader from '@/components/ToolbarHeader.vue'
import FormInput from '@/components/formInput.vue'
import FormLabel from '@/components/FormLabel.vue'
import FormSelect from '@/components/FormSelect.vue'
import FormNumber from '@/components/FormNumber.vue'
// import { confirmDelete2 } from '@/utils/confirmDelete'
import { exportExcelHelper, exportPDFAPI } from '@/utils/exportData'
import { confirmDelete } from '@/services/data/lou'
const data = []

export default {
  components: {
    // formModal,
    ToolbarHeader, FormSelect, FormInput, FormLabel, FormNumber,
  },
  data() {
    return {
      name: 'master_bahan_baku',
      ApiUrl: 'master/bahan_baku',
      pageTitle: 'Data Bahan Baku',
      searchText: '',
      searchInput: null,
      searchedColumn: '',
      columns: [
        createActionColumn(),
        createFilterableColumn('nama', null, this.searchFocus),
        createFilterableColumn('kode', null, this.searchFocus),
        createFilterableColumn('nama_supplier', null, this.searchFocus),
        createFilterableColumn('nama_kategori', null, this.searchFocus),
        createFilterableColumn('satuan', null, this.searchFocus),
        createNumberColumn('Harga', 'harga', 200),
        createNumberColumn('Re-Order', 'reorder', 200),
      ],
      table: '',
      form: this.$form.createForm(this, { name: 'Form ' + this.table }),
      data,
      formvisible: false,
      modalInput: {
        nama: '',
        kode: '',
        supplier_id: '',
        kategori_id: '',
        satuan: '',
        harga: 0,
        reorder: '0',
      },
      masterDataSupplier: [],
      masterDataKategori: [],
    }
  },
  mounted: function () {
    const date = moment().format('YYYY-MM-DD') //
    this.tgl1 = date
    this.tgl2 = date
    this.getAllData()
    this.getDataMaster()
  },
  methods: {
    searchFocus() {
      this.searchInput.focus();
    },
    async getDataMaster() {
      const supplier = await getMasterCustom('master/supplier')
      this.masterDataKategori = await getMasterCustom('master/kategori_bahan')
      this.masterDataSupplier = addLabelForSelect(supplier, 'nama_perusahaan', 'nama_kontak')
    },
    async exportPdf() {
      await exportPDFAPI(`${this.ApiUrl}?preview=pdf`)
    },
    async exportExcel() {
      await exportExcelHelper(this.columns, this.data, `${this.pageTitle}.xlsx`)
    },
    moment,
    showModal(action, data = {}) {
      this.resetForm()
      this.formvisible = true
      this.action = action
      if (action === 'update') {
        this.modalInput = this.$g.clone(data)
        this.editdata = data
      }
    },
    async getAllData(showNotif = false) {
      var response = await getMasterCustom(this.ApiUrl, showNotif, this.loadingRefresh)
      this.data = response
    },
    async showDeleteConfirm(deldata) {
      await confirmDelete(this.ApiUrl, deldata.id, this.getAllData);
      // confirmDelete2(this.ApiUrl, deldata.id, this.getAllData)
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm()
      this.searchText = selectedKeys[0]
      this.searchedColumn = dataIndex
    },

    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    async handleSubmit() {
      await sendToAPI({
        action: this.action,
        url: this.ApiUrl,
        formData: this.modalInput,
        onSuccess: () => {
          this.getAllData()
          this.resetForm()
        },
      })
    },
    resetForm() {
      this.formvisible = false
      this.action = 'create'
      this.modalInput = {
        nama: '',
        kode: '',
        supplier_id: '',
        kategori_id: '',
        satuan: '',
        harga: '',
        reorder: '0',
      }
    },
  },
}
</script>
